import { render, staticRenderFns } from "./ActivePeopleByRoleCard.vue?vue&type=template&id=193bebd2&scoped=true"
import script from "./ActivePeopleByRoleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivePeopleByRoleCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActivePeopleByRoleCard.vue?vue&type=style&index=0&id=193bebd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bebd2",
  null
  
)

export default component.exports